export const VIEW = { HIDDEN: 'hidden', BANNER: 'banner', MANAGE: 'manage' };

// The upfront banner appears wherever the visitor still has something to be
// told:
//  - Notice mode: every undecided visitor, any posture — the banner IS the
//    notice that engagement-based tracking rests on ("we told you, you kept
//    browsing"), so it must be visible before any implied grant can fire.
//  - Consent mode (default): only where consent is required before tracking —
//    the opt-in states (CA/FL/PA/IL), international, and unknown-region
//    visitors. In opt-out states tracking runs by default, so no banner; the
//    "Your Privacy Choices" footer link opens the settings center on demand.
// An explicit prior decision hides the banner in every case.
export function restingViewFor({ decided, posture, noticeMode }) {
  if (decided) { return VIEW.HIDDEN; }
  if (noticeMode) { return VIEW.BANNER; }

  return posture !== 'opt_out' ? VIEW.BANNER : VIEW.HIDDEN;
}
